// rem.js
(function (draftWidth, n) {
    function getRem() {
        var html = document.querySelector("html");
        var w = document.body.clientWidth || document.documentElement.clientWidth;
        var rem = (w / draftWidth) * n;
        // html.style.fontSize = rem + "px !important";
        html.setAttribute("style", "font-size:" + rem + "px !important");
    }
    getRem();
    window.addEventListener("resize",function(){
        getRem();
    });
})(750,6);